export const ANULOMA_STEPS = [
  { value: '1:0:1', label: '1:0:1' },
  { value: '1:0:2', label: '1:0:2' },
  { value: '1:1:1', label: '1:1:1' },
  { value: '1:1:2', label: '1:1:2' },
  { value: '1:2:2', label: '1:2:2' },
  { value: '1:3:2', label: '1:3:2' },
  { value: '1:4:2', label: '1:4:2' }
];

const COMMON_SOUND_SETTINGS = [
  {
    title: 'Громкость отсчета',
    text: 'управляет короткими сигналами и голосом. Значение 0 полностью выключает звуковой отсчет и голосовые подсказки.'
  },
  {
    title: 'Звук',
    text: 'меняет характер коротких сигналов: можно выбрать мягкий тон, воздух, колокольчик, каплю, плеск, теплый тон или деревянный звук.'
  },
  {
    title: 'Сигналы',
    text: 'задают частоту подсказок: каждую секунду и на смене фаз, только на смене фаз или без звука.'
  },
  {
    title: 'Голос',
    text: 'произносит фазы дыхания. «Каждая фаза» помогает новичкам, «Первый круг» подсказывает только в начале, «Без голоса» оставляет практику без речи.'
  },
  {
    title: 'Фон',
    text: 'добавляет спокойный звуковой слой: дождь, воду, огонь, лес, море, ветер или розовый шум.'
  },
  {
    title: 'Громкость фона',
    text: 'появляется после выбора фонового звука и регулирует только фон, отдельно от сигналов и голоса.'
  },
  {
    title: 'Сохранение',
    text: 'после кнопки «Сохранить» выбранные параметры остаются в этом браузере для этой практики.'
  }
];

export const practices = {
  anuloma: {
    id: 'anuloma',
    path: '/anuloma-viloma',
    title: 'Анулома-вилома',
    label: 'Анулома-вилома',
    eyebrow: 'Попеременное дыхание',
    cardText: 'Спокойная пранаяма с вдохом, возможной задержкой и удлиненным выдохом. Подходит для регулярной практики и мягкой концентрации.',
    seoTitle: 'Дыхание Анулома-вилома онлайн - тренажер пранаямы',
    seoDescription: 'Онлайн-тренажер дыхания Анулома-вилома с таймером, настройками ступени, вдоха и выдоха для спокойной дыхательной практики.',
    seoKeywords: 'дыхание анулома-вилома, пранаяма онлайн, техника дыхания, тренажер для дыхания, дыхание от стресса онлайн',
    defaults: {
      sessionTime: 5,
      inhaleTime: 7,
      selectedStep: '1:0:1',
      volume: 5
    },
    settings: {
      sessionTime: true,
      inhaleTime: true,
      step: true,
      volume: true
    },
    info: {
      title: 'Анулома-вилома: попеременное дыхание для спокойной практики',
      lead: 'Анулома-вилома - мягкая дыхательная практика с попеременным дыханием через ноздри. В онлайн-тренажере можно выбрать ступень, длительность вдоха и общий таймер сеанса, чтобы удерживать ровный ритм без самостоятельного подсчета.',
      sections: [
        {
          title: 'Как устроена практика',
          text: 'Базовый вариант начинается с равного вдоха и выдоха. По мере освоения можно использовать ступени с задержкой дыхания и удлиненным выдохом. Важно двигаться постепенно и не превращать задержку в усилие.'
        },
        {
          title: 'Как пользоваться настройками',
          text: 'Откройте «Настройки» перед стартом, выберите комфортный ритм и нажмите «Сохранить». Эти параметры сохранятся для Анулома-виломы в текущем браузере.',
          items: [
            {
              title: 'Время сеанса',
              text: 'задает общую длительность практики от 1 до 30 минут.'
            },
            {
              title: 'Длина вдоха',
              text: 'задает базовый счет вдоха; от него рассчитываются задержка и выдох по выбранной ступени.'
            },
            {
              title: 'Ступень освоения',
              text: 'меняет соотношение вдоха, задержки и выдоха. Начинайте с 1:0:1 или 1:0:2 и переходите дальше только при спокойном дыхании.'
            },
            ...COMMON_SOUND_SETTINGS
          ]
        },
        {
          title: 'Для чего подходит',
          text: 'Практику часто выбирают для спокойной концентрации, вечернего расслабления и мягкой саморегуляции. Ритм помогает переключить внимание на дыхание и сделать паузу в напряженном дне.'
        },
        {
          title: 'Как заниматься безопасно',
          text: 'Если появляется головокружение, давление, тревога или нехватка воздуха, остановите таймер и вернитесь к естественному дыханию. При хронических заболеваниях, беременности или сомнениях лучше обсудить практику со специалистом.'
        }
      ]
    }
  },
  breathing478: {
    id: 'breathing478',
    path: '/breathing-4-7-8',
    title: 'Дыхание 4-7-8',
    label: 'Техника 4-7-8',
    eyebrow: 'Для сна и расслабления',
    cardText: 'Вдох на 4 счета, задержка на 7 и длинный выдох на 8. Ритм помогает переключить внимание с тревожных мыслей на дыхание.',
    seoTitle: 'Дыхание 4-7-8 онлайн - техника дыхания для сна и стресса',
    seoDescription: 'Практикуйте дыхание 4-7-8 онлайн: вдох 4 секунды, задержка 7 секунд, выдох 8 секунд. Таймер для расслабления и подготовки ко сну.',
    seoKeywords: 'дыхание 4-7-8, дыхание для сна, техника дыхания, дыхание от стресса онлайн, тренажер для дыхания',
    defaults: {
      sessionTime: 2,
      volume: 5
    },
    settings: {
      sessionTime: true,
      volume: true
    },
    fixedPhases: [
      { key: 'inhale', label: 'Вдох', duration: 4 },
      { key: 'hold', label: 'Задержка', duration: 7 },
      { key: 'exhale', label: 'Выдох', duration: 8 }
    ],
    info: {
      title: 'Дыхание 4-7-8: техника для сна, стресса и вечернего успокоения',
      lead: 'Метод 4-7-8 строится на коротком вдохе, мягкой задержке и длинном выдохе. Такой ритм удобно использовать вечером, после напряженного дня или в момент, когда нужно снизить внутреннюю суету.',
      sections: [
        {
          title: 'Как работает ритм 4-7-8',
          text: 'Счет задает понятную структуру: вдох на 4 секунды, задержка на 7 секунд и выдох на 8 секунд. Длинный выдох помогает дышать медленнее, а внимание постепенно возвращается из тревожных мыслей к телу.'
        },
        {
          title: 'Сколько практиковать в начале',
          text: 'Начните с 2 минут: это мягкий и бережный формат знакомства с ритмом 4-7-8, если дыхание остается комфортным. Если хочется продолжить, запустите сеанс заново или увеличьте время сеанса в настройках.'
        },
        {
          title: 'Как пользоваться настройками',
          text: 'В технике 4-7-8 сам ритм фиксирован: вдох 4 секунды, задержка 7 секунд и выдох 8 секунд. В настройках можно менять длительность сеанса и звуковое сопровождение.',
          items: [
            {
              title: 'Время сеанса',
              text: 'задает общую длительность от 1 до 30 минут. По умолчанию стоит 2 минуты, чтобы начать мягко и без перегрузки.'
            },
            ...COMMON_SOUND_SETTINGS
          ]
        },
        {
          title: 'Когда практиковать',
          text: 'Техника часто используется как дыхание для сна, дыхание от стресса онлайн и короткая практика расслабления. Начинайте с нескольких циклов и не удерживайте воздух через напряжение.'
        },
        {
          title: 'Безопасность',
          text: 'Если появляется головокружение, нехватка воздуха или дискомфорт, остановитесь и вернитесь к обычному дыханию. При заболеваниях сердца, легких, беременности или панических состояниях лучше обсудить дыхательные практики со специалистом.'
        }
      ]
    }
  },
  box: {
    id: 'box',
    path: '/box-breathing',
    title: 'Дыхание по квадрату',
    label: 'Дыхание по квадрату',
    eyebrow: 'Фокус и контроль стресса',
    cardText: 'Все четыре фазы одинаковые: вдох, задержка после вдоха, выдох и задержка после выдоха. Простая техника для концентрации и восстановления ровного темпа.',
    seoTitle: 'Дыхание по квадрату онлайн - box breathing тренажер',
    seoDescription: 'Онлайн-тренажер дыхания по квадрату: вдох, задержка после вдоха, выдох и задержка после выдоха одной длины. Техника дыхания для концентрации и контроля стресса.',
    seoKeywords: 'дыхание по квадрату, box breathing, техника дыхания, дыхание от стресса онлайн, тренажер для дыхания',
    defaults: {
      sessionTime: 5,
      phaseLength: 4,
      volume: 5
    },
    settings: {
      sessionTime: true,
      phaseLength: true,
      volume: true
    },
    info: {
      title: 'Дыхание по квадрату: ровный ритм для концентрации',
      lead: 'Дыхание по квадрату, или box breathing, использует четыре равные стороны: вдох, задержку после вдоха, выдох и задержку после выдоха. Ровный счет делает практику простой и предсказуемой.',
      sections: [
        {
          title: 'Для чего подходит',
          text: 'Эта техника дыхания помогает замедлиться, собраться перед работой, учебой, выступлением или разговором. Ее часто выбирают как короткое дыхание от стресса онлайн, когда нужна ясность и устойчивость.'
        },
        {
          title: 'Как выполнять',
          text: 'Самый распространенный базовый вариант - 4 секунды на каждую фазу: вдох 4, задержка после вдоха 4, выдох 4 и задержка после выдоха 4. Именно поэтому в тренажере по умолчанию стоит значение 4 секунды.'
        },
        {
          title: 'Как пользоваться настройками',
          text: 'В дыхании по квадрату все четыре фазы остаются равными. Настройки помогают сделать квадрат короче, длиннее, тише или удобнее для практики без взгляда на экран.',
          items: [
            {
              title: 'Время сеанса',
              text: 'задает общую длительность практики от 1 до 30 минут.'
            },
            {
              title: 'Время каждой фазы',
              text: 'меняет длину всех четырех сторон квадрата сразу: вдох, задержку после вдоха, выдох и задержку после выдоха.'
            },
            ...COMMON_SOUND_SETTINGS
          ]
        },
        {
          title: 'Сколько секунд выбрать',
          text: '3 секунды подойдут новичкам, детям и моментам сильного напряжения, когда длинные задержки ощущаются тяжело. 4 секунды - универсальный стандарт для большинства пользователей. 5 секунд можно выбрать, если дыхание остается спокойным и хочется глубже замедлиться. 6 секунд и выше лучше использовать только при хорошем опыте, без одышки и без желания "дотерпеть" счет.'
        },
        {
          title: 'Как подобрать свое значение',
          text: 'Начните с 4 секунд и сделайте 3-4 цикла. Если дыхание ровное, плечи расслаблены и нет нехватки воздуха, можно оставить 4 или попробовать 5 секунд. Если появляется напряжение, сбивчивый вдох, головокружение или желание резко вдохнуть после паузы, уменьшите длительность до 3 секунд.'
        },
        {
          title: 'Мягкий режим',
          text: 'Практика не должна вызывать борьбу с дыханием. Держите плечи расслабленными, не поднимайте грудь чрезмерно и возвращайтесь к естественному дыханию при дискомфорте.'
        }
      ]
    }
  },
  custom: {
    id: 'custom',
    path: '/custom-breathing',
    title: 'Свой вариант',
    label: 'Свой вариант',
    eyebrow: 'Настройка под себя',
    cardText: 'Соберите собственный цикл: вдох, задержка после вдоха, выдох и задержка после выдоха. Подходит для мягких экспериментов с ритмом.',
    seoTitle: 'Тренажер дыхания онлайн - настройка вдоха, выдоха и задержек',
    seoDescription: 'Настройте собственную технику дыхания онлайн: длительность вдоха, задержки после вдоха, выдоха и задержки после выдоха в удобном тренажере.',
    seoKeywords: 'тренажер для дыхания, техника дыхания онлайн, дыхание от стресса онлайн, настроить дыхание, дыхательные упражнения',
    defaults: {
      sessionTime: 5,
      inhaleTime: 4,
      holdAfterInhale: 2,
      exhaleTime: 6,
      holdAfterExhale: 0,
      volume: 5
    },
    settings: {
      sessionTime: true,
      customPhases: true,
      volume: true
    },
    info: {
      title: 'Свой вариант дыхания: настройте личный ритм',
      lead: 'Этот режим нужен, когда готовые техники не подходят по темпу. Вы можете отдельно задать вдох, задержку после вдоха, выдох и задержку после выдоха.',
      sections: [
        {
          title: 'Как подобрать длительность',
          text: 'Начните с коротких и комфортных значений. Часто удобнее делать выдох немного длиннее вдоха, а задержки добавлять постепенно, без напряжения.'
        },
        {
          title: 'Как пользоваться настройками',
          text: 'В своем варианте можно собрать личный цикл дыхания. Настройте фазы перед стартом и сохраните их: тренажер запомнит этот ритм в текущем браузере.',
          items: [
            {
              title: 'Время сеанса',
              text: 'задает общую длительность практики от 1 до 30 минут.'
            },
            {
              title: 'Вдох',
              text: 'задает длительность вдоха. Начинайте с такого значения, при котором не приходится добирать воздух.'
            },
            {
              title: 'Задержка после вдоха',
              text: 'добавляет паузу на полном вдохе. Значение 0 выключает эту фазу.'
            },
            {
              title: 'Выдох',
              text: 'задает длительность выдоха. Часто комфортно делать его чуть длиннее вдоха.'
            },
            {
              title: 'Задержка после выдоха',
              text: 'добавляет паузу после выдоха. Значение 0 выключает эту фазу.'
            },
            ...COMMON_SOUND_SETTINGS
          ]
        },
        {
          title: 'Для чего использовать',
          text: 'Свой режим подходит для спокойной разминки, дыхания для сна, тренировки концентрации или восстановления после нагрузки. Главное - сохранять плавность и ощущение контроля.'
        },
        {
          title: 'Когда остановиться',
          text: 'Остановите практику, если появляется головокружение, давление в груди, тревога или ощущение нехватки воздуха. Дыхательный тренажер не заменяет медицинскую помощь.'
        }
      ]
    }
  }
};

export const practiceList = [
  practices.breathing478,
  practices.box,
  practices.anuloma,
  practices.custom
];
